import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import StoneServicesHero from './components/StoneServicesHero';
import ServiceFeatures from './components/ServiceFeatures';
import StoneGallery from './components/StoneGallery';
import QuoteForm from './components/QuoteForm';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://lgconcretepumping.com';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': `${SITE_URL}/services/stone-services#service`,
  name: 'Stone Installation Services',
  url: `${SITE_URL}/services/stone-services`,
  description:
    'Expert stone installation including retaining walls, patios, walkways, and decorative landscaping in Western NC. LG Concrete Pumping & Stone LLC.',
  provider: { '@id': `${SITE_URL}/#business` },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Western North Carolina' },
    { '@type': 'AdministrativeArea', name: 'North Georgia' },
    { '@type': 'AdministrativeArea', name: 'Southwest South Carolina' },
  ],
  serviceType: 'Stone Installation',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Stone Installation Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Retaining Walls' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Stone Patios' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Walkways & Pathways' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Decorative Landscaping Stone' } },
    ],
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
    { '@type': 'ListItem', position: 2, name: 'Services', item: `${SITE_URL}/services` },
    { '@type': 'ListItem', position: 3, name: 'Stone Services', item: `${SITE_URL}/services/stone-services` },
  ],
};

const StoneServicesPage = () => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];
    [serviceSchema, breadcrumbSchema].forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Stone Installation Services | LG Concrete Pumping & Stone LLC Otto NC';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Expert stone installation — retaining walls, patios, walkways, and decorative landscaping in Western NC. LG Concrete Pumping & Stone LLC, Otto NC. Call (828) 634-1304.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/services/stone-services`);

    return () => { scripts.forEach((s) => s.remove()); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <StoneServicesHero />
        <ServiceFeatures />
        <StoneGallery />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
};

export default StoneServicesPage;
